/**
 * Visual tokens shared by the Brand Knowledge list components — the prompt-studio mock's
 * palette (docs/mocks/prompt-studio/assets/app.css), which mirrors theme/theme.ts.
 */
export const K = {
  primary: '#7C3AED',
  primaryDark: '#6D28D9',
  primarySoft: 'rgba(124, 58, 237, 0.08)',
  primarySoft2: 'rgba(124, 58, 237, 0.16)',
  focusRing: '0 0 0 3px rgba(124, 58, 237, 0.10)',
  ink: '#0B0B0F',
  ink2: '#6B6B6B',
  ink3: '#A1A1A1',
  line: 'rgba(0, 0, 0, 0.09)',
  segBg: '#F3F3F6',
  rowHover: '#FCFBFF',
  headBg: '#FAFBFD',
  chipBg: '#F4F4F5',
  paper: '#FFFFFF',
  warning: '#F59E0B',
  warningInk: '#92400E',
  error: '#EF4444',
  errorInk: '#B91C1C',
  tight: '"Inter Tight", "Inter", sans-serif',
} as const;

/** The uppercase micro-label of the mock (column heads, group heads). */
export const microLabel = {
  fontSize: 10.5,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: K.ink3,
} as const;

/** `<mark>` for search hits. */
export const markSx = {
  '& mark': { bgcolor: K.primarySoft2, color: K.primaryDark, borderRadius: '3px', px: '1px' },
} as const;
